import * as React from 'react';
import Cookies from 'lib/Cookies';
import Electron from 'lib/Electron';
import Notice from 'components/Notice';
import Row from 'components/Row';

export function getPersistFromCookie() {
  if (typeof Cookies.get('persist') === 'undefined') {
    const defaultValue = Electron.isAvailable() ? 'true' : 'false';
    Cookies.set('persist', defaultValue);
  }
  return Cookies.get('persist') === 'true';
}

export function setPersistCookie(persist: boolean) {
  Cookies.set('persist', persist ? 'true' : 'false');
}

export function CookieWarning() {
  return Cookies.isEnabled() ? null : (
    <Row>
      <Notice color="apple">
        Cookies are not enabled on your browser. Please enable cookies in your browser preferences
        to continue.
      </Notice>
    </Row>
  );
}
